
<ng-container *ngIf="installation">

    <br>
<div class="row">
    <div class="col-sm-2">
        <p>Administrateur Windows : </p>
    </div>
    <div class="col-sm-3"><input type="text" class="form-control" value="{{installation.machine.win_username}}" autocomplete="off"></div>
    <div class="w-100"></div>
    <div class="col-sm-2">
        <p>Mot de passe Windows :</p>
    </div>
    <ng-container *ngIf="installation">
        <div class="col-sm-3 posswordcontainer">
            <input mat-input type="password" value="{{installation.machine.win_password}}" class="form-control" id="ucppwd" (dblclick)="showPwd('ucppwd')" autocomplete="off">
            <mat-icon class="type-toggle material-icons pointer passwordeye" (click)="showPwd('ucppwd')">
                visibility
            </mat-icon>
        </div>
        

        
    </ng-container>
    <div class="w-100"></div>
    <div class="col-sm-2">
        <p>Mot de passe Splashtop :</p>
    </div>
    <ng-container *ngIf="installation">
        <div class="col-sm-3">
            <input type="password" value="{{installation.machine.lmi_password}}" class="form-control" id="splshtppwd" (dblclick)="showPwd('splshtppwd')" autocomplete="off">
            <mat-icon class="type-toggle material-icons pointer passwordeye" (click)="showPwd('splshtppwd')">
                visibility
            </mat-icon>
        </div>
        
    </ng-container>
    <p class="w-100"></p>
    <div class="tunneling col-sm-12 form-group form-check">
        <input type="checkbox" name="tunnel" id="tunnel" checked class="form-check-input">
        <label for="tunnel" class="form-check-label">Tunneling V3 : </label>
        <button class="btn btn-info btn-block" (click)="connect()" style="margin-left: 50px; margin-bottom: 10px;">Connexion au Distributeur</button>
    </div>

    <div>
        <p>Losque vous faites des <b>modifications</b>, n'oubliez pas de créer une intervention !</p>
    </div>
</div>
</ng-container>